import { Popover } from '@headlessui/react';
import SharePostPopover from 'components/desktop/detail/main-section/main-section-right/creator-information/share-post-popover';
import FriendActions from 'components/desktop/shared/friend-actions';
import { IconLocationFill, IconPhone, IconShareVariantOutline } from 'components/icons';
import { B2CUser, FileWithFullUrls, UserUsers } from 'graphql/main/queries';
import { useTranslation } from 'hooks';
import { isEmpty, toString } from 'lodash';
import Image from 'next/image';
import { DetailBrokerPageContext } from 'pages/moi-gioi/[chi-tiet-moi-gioi]';
import { Fragment, useContext, useState } from 'react';

const Information = () => {
  const { user } = useContext(DetailBrokerPageContext).pageData ?? {};
  const translation = useTranslation();
  const [showingPhoneNumber, setShowingPhoneNumber] = useState(false);
  const [isPhoneNumberCopied, setIsPhoneNumberCopied] = useState(false);

  const copyPhoneNumber = () => {
    (user as B2CUser)?.phones?.[0] &&
      navigator.clipboard.writeText(toString((user as B2CUser)?.phones?.[0]));
    setIsPhoneNumberCopied(true);
    const copyTimeout = setTimeout(() => {
      setIsPhoneNumberCopied(false);
      clearTimeout(copyTimeout);
    }, 2 * 1000);
  };

  return (
    <div className='container absolute top-[168px] left-1/2 z-[25] min-w-[1052px] -translate-x-1/2 space-x-[24px] px-[80px] screen-1140:px-[122px] xl:px-[72px] screen-1366:px-[107px]'>
      <div className='flex h-[190px] space-x-[24px] rounded-[8px] bg-paper p-[24px] shadow-23'>
        <div className='relative h-[140px] min-w-[140px] overflow-hidden rounded-full'>
          <Image
            src={
              user?.avatar
                ? (user.avatar as FileWithFullUrls)?.originalUrl ?? '/images/default-avatar.svg'
                : '/images/default-avatar.svg'
            }
            alt={
              user?.avatar
                ? (user.avatar as FileWithFullUrls)?.originalUrl ?? '/images/default-avatar.svg'
                : '/images/default-avatar.svg'
            }
            layout='fill'
            objectFit='cover'
            placeholder='blur'
            blurDataURL='/images/image-loader.svg'
          />
        </div>
        <div className='flex w-full flex-col justify-between'>
          <div className='flex h-fit w-full flex-col justify-center space-y-[16px]'>
            {user && (
              <Fragment>
                <span className='text-[24px] font-[600] leading-[30px]'>{user.fullName}</span>
                <div className='flex items-center space-x-[8px] text-[12px] leading-[15px] text-text2'>
                  {(user as B2CUser)?.type && (
                    <span>
                      {(translation.major.b2cUserTypes as any)[toString((user as B2CUser)?.type)]}
                    </span>
                  )}
                  {user.province && (
                    <Fragment>
                      {!isEmpty((user as B2CUser)?.type) && !isEmpty(user.province.name) && (
                        <span>{'\u2022'}</span>
                      )}
                      <div className='flex items-center space-x-[8px]'>
                        <IconLocationFill className='h-[16px] w-[16px]' />
                        <span>{user.province.name ?? 'Đang cập nhật'}</span>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>
            )}
          </div>
          <div className='h-[0.5px] bg-stroke' />
          <div className='relative flex justify-between'>
            <div className='w-[270px]'>
              <FriendActions user={user as UserUsers} />
            </div>
            <div className='flex w-fit justify-end space-x-[12px] pl-[24px]'>
              {(user as B2CUser)?.phones?.[0] && (
                <Fragment>
                  <button
                    type='button'
                    className='flex h-[40px] min-w-[186px] items-center justify-center space-x-[8px] rounded-[8px] bg-secondary px-[16px] text-primary transition duration-[200ms] ease-in-out hover:bg-secondary-light'
                    onClick={() => {
                      if (!showingPhoneNumber) {
                        setShowingPhoneNumber(true);
                      } else {
                        copyPhoneNumber();
                      }
                    }}
                  >
                    <IconPhone className='h-[22px] w-[22px]' />
                    <span className='truncate font-[600]'>
                      {showingPhoneNumber
                        ? `${(user as B2CUser)?.phones?.[0]} . ${
                            isPhoneNumberCopied ? 'Đã sao chép' : 'Sao chép'
                          }`
                        : `${toString((user as B2CUser)?.phones?.[0].slice(0, 6))} **** . Hiện số`}
                    </span>
                  </button>
                </Fragment>
              )}
              <div className='w-[1px] bg-stroke' />
              <Popover className='relative'>
                {({ open }) => (
                  <Fragment>
                    <Popover.Button
                      type='button'
                      className='flex h-[40px] items-center space-x-[6px]'
                    >
                      <IconShareVariantOutline className='h-[20px] w-[20px]' />
                      <span>Chia sẻ</span>
                    </Popover.Button>
                    {
                      <div className={`${open ? 'block' : 'hidden'}`}>
                        <SharePostPopover />
                      </div>
                    }
                  </Fragment>
                )}
              </Popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
